module.exports = __webpack_public_path__ + "img/ice_london.30fc1329.png";